module.exports = __webpack_public_path__ + "static/media/seventh_covered_bridge.0dd23a5f.mp4";